<template>
  <div class="userCenterCon">
    <div
      class="ucTop"
      v-if="islogin"
    >
      <img
        :src="userPic"
        :onerror="defaultImg"
        alt=""
        class="imgUC"
      >
      <p class="nameUC">{{userName}}</p>
    </div>
    <div
      class="ucTop"
      v-else
      @click="tologin()"
    >
      <img
        src="../assets/imgs/defaultUCpic.png"
        :onerror="defaultImg"
        alt=""
        class="imgUC"
      >
      <p class="nameUC">点击登录</p>
    </div>
    <div
      class="itemsUC"
      v-if="islogin"
    >
      <a @click="goto('cl')">
        <mt-cell
          title="我的订单"
          is-link
        >
          <img
            slot="icon"
            src="../assets/imgs/orderUC.png"
            class="ucIcon4"
          >
        </mt-cell>
      </a>
      <a @click="goto('sc')">
        <mt-cell
          title="我的收藏"
          is-link
        >
          <img
            slot="icon"
            src="../assets/imgs/shoucangUC.png"
            class="ucIcon4"
          >
        </mt-cell>
      </a>
      <a @click="goto('nl')">
        <mt-cell
          title="消息公示栏"
          is-link
        >
          <img
            slot="icon"
            src="../assets/imgs/noticeUC.png"
            class="ucIcon4"
          >
        </mt-cell>
      </a>
      <a @click="goto('ui')">
        <mt-cell
          title="我的资料"
          is-link
        >
          <img
            slot="icon"
            src="../assets/imgs/myInfoUC.png"
            class="ucIcon4"
          >
        </mt-cell>
      </a>
    </div>
    <div
      class="itemsUC"
      v-else
    >
      <a @click="alertmsg()">
        <mt-cell
          title="我的订单"
          is-link
        >
          <img
            slot="icon"
            src="../assets/imgs/orderUC.png"
            class="ucIcon4"
          >
        </mt-cell>
      </a>
      <a @click="alertmsg()">
        <mt-cell
          title="我的收藏"
          is-link
        >
          <img
            slot="icon"
            src="../assets/imgs/shoucangUC.png"
            class="ucIcon4"
          >
        </mt-cell>
      </a>
      <a @click="alertmsg()">
        <mt-cell
          title="消息公示栏"
          is-link
        >
          <img
            slot="icon"
            src="../assets/imgs/noticeUC.png"
            class="ucIcon4"
          >
        </mt-cell>
      </a>
      <a @click="alertmsg()">
        <mt-cell
          title="我的资料"
          is-link
        >
          <img
            slot="icon"
            src="../assets/imgs/myInfoUC.png"
            class="ucIcon4"
          >
        </mt-cell>
      </a>
    </div>
    <div
      v-if="islogin"
      class="exit"
      @click="unBind()"
    >退出登录</div>
    <tabbar></tabbar>
  </div>
</template>

<script>
import tabbar from '../components/tabbar.vue' // 引用组件的地址

import { MessageBox, Toast } from 'mint-ui'
import { getaccountInfo, cleanOpenid } from '../../src/api/Api'

export default {
  name: 'userinfos',
  components: {
    tabbar: tabbar
  },
  data () {
    return {
      myPageTit: '个人中心',
      userinfo: {},
      openid: localStorage.getItem('openid'),
      userId: sessionStorage.getItem('userId'),
      userPic: sessionStorage.getItem('photo'),
      userName: sessionStorage.getItem('userName'),
      phone: sessionStorage.getItem('phone'),
      sex: sessionStorage.getItem('sex'),
      defaultImg:
        'this.src="' + require('../assets/imgs/defaultUCpic.png') + '"', // 默认图地址
      islogin: true,
      baseUrl: window.baseapi.baseApiUrl,
      loadingCompleted: false // jiazai
    }
  },
  methods: {
    getaccountInfo () {
      if (
        localStorage.getItem('openid') === '' ||
        localStorage.getItem('openid') === null ||
        localStorage.getItem('openid') === undefined
      ) {
        this.$router.replace({
          path: '/Au',
          query: { pageName: 'home' }
        })
        return false
      }
      this.$axios({
        method: 'get',
        url: this.baseUrl + '/safeStudy/login/wxCheckOpenid',
        params: { openid: localStorage.getItem('openid') }
      }).then(res => {
        if (res.data.code === '200') {
          console.log('绑定了' + res.data.data[0].StuName)
          sessionStorage.setItem('token', res.data.data[0].token)
          this.loadingCompleted = true // 加载成功
          sessionStorage.setItem('platform', '0') // 继续教育0  专项学习1
          this.$store.dispatch('SetToken', res.data.data[0].token)
          this.$store.dispatch('SetStuId', res.data.data[0].uid)
          this.$store.dispatch('SetPlatform', '0')
          this.$store.dispatch('SetProfessionId', res.data.data[0].ProfessionId) // 货运1  客运2 危险3 出租5
          sessionStorage.setItem('userName', res.data.data[0].StuName)
          sessionStorage.setItem('sex', res.data.data[0].Sex)
          sessionStorage.setItem('phone', res.data.data[0].Phone)
          sessionStorage.setItem('photo', res.data.data[0].PhotoImage)
          sessionStorage.setItem('userId', res.data.data[0].uid)
          sessionStorage.setItem('companyId', res.data.data[0].Company)
          sessionStorage.setItem('professionId', res.data.data[0].ProfessionId)
          sessionStorage.setItem(
            'professionName',
            res.data.data[0].ProfessionName
          )
          sessionStorage.setItem('IdCard', res.data.data[0].IdCard)
          sessionStorage.setItem('driverNumber', res.data.data[0].driverNumber)
          sessionStorage.setItem('CertificateNo', res.data.data[0].Certificate)
          sessionStorage.setItem('register', res.data.data[0].register)

          sessionStorage.setItem('companyName', res.data.data[0].CompanyName)
          this.userId = res.data.data[0].uid
          this.phone = res.data.data[0].Phone
          this.userName = res.data.data[0].StuName
          this.userPic = res.data.data[0].PhotoImage
        } else {
          this.islogin = false
        }
      })
    },
    unBind () {
      if (!this.loadingCompleted) {
        return false
      }
      MessageBox({
        title: '提示',
        message: '确定要退出吗?',
        showCancelButton: true
      }).then(action => {
        if (action === 'confirm') {
          cleanOpenid({
            mobile: this.phone,
            openid: this.openid
          }).then(res => {
            if (res.data.code === 200) {
              Toast('退出登录成功')
              localStorage.removeItem('openid')
              sessionStorage.removeItem('token')
              sessionStorage.removeItem('platform')
              sessionStorage.removeItem('userName')
              sessionStorage.removeItem('sex')
              sessionStorage.removeItem('phone')
              sessionStorage.removeItem('photo')
              sessionStorage.removeItem('userId')
              sessionStorage.removeItem('stuId')
              sessionStorage.removeItem('companyId')
              sessionStorage.removeItem('professionId')
              sessionStorage.removeItem('professionName')
              sessionStorage.removeItem('IdCard')
              sessionStorage.removeItem('driverNumber')
              sessionStorage.removeItem('companyName')
              sessionStorage.removeItem('register')
              sessionStorage.removeItem('CertificateNo')
              this.$router.push({ path: '/' })
            } else {
              Toast('退出登录失败')
            }
          })
        }
      })
    },
    tologin () {
      // 未绑定
      this.$router.push({
        path: '/login'
      })
    },
    alertmsg () {
      Toast('请先点击登录！')
    },
    goto (value) {
      if (!this.loadingCompleted) {
        return false
      }
      if (value === 'cl') {
        this.$router.push({
          path: '/cl'
        })
      }
      if (value === 'sc') {
        this.$router.push({
          path: '/sc',
          query: { eid: this.userId }
        })
      }
      if (value === 'nl') {
        this.$router.push({
          path: '/nl',
          query: { eid: this.userId }
        })
      }
      if (value === 'ui') {
        this.$router.push({
          path: '/ui'
        })
      }
    }
  },
  created () {
    this.openid = localStorage.getItem('openid')
    if (
      this.openid === '' ||
      this.openid === null ||
      this.openid === undefined
    ) {
      console.log('跳转过来的' + this.openid)
      this.$router.replace({
        path: '/'
      })
    } else {
      this.getaccountInfo()
    }
  },
  beforeRouteEnter (to, from, next) {
    var u = navigator.userAgent
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    // XXX: 修复iOS版微信HTML5 History兼容性问题
    if (isiOS && to.path !== location.pathname) {
      // 此处不可使用location.replace
      location.assign(to.fullPath)
    } else {
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/UserCenter.vue